import logoVariants from '@/assets/img/logo';
import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';

const LogoSpinner = ({ isLoading = true, width = '80px' }: { isLoading?: boolean; width?: string }) => {
  const controls = useAnimation();

  useEffect(() => {
    if (isLoading) {
      controls.start({
        rotate: 360,
        transition: {
          ease: 'linear',
          duration: 2,
          repeat: Infinity,
        },
      });
    } else {
      controls.stop();
    }
  }, [isLoading, controls]);

  return (
    <motion.img src={logoVariants.purpleNoText160x160} alt="Logo" width={width} height={width} animate={controls} />
  );
};
export default LogoSpinner;
